<template>
  <div class="s-layout" :style="colorObject">
    <div class="s-container">
      <Header
        v-if="true"
        :page-title="getModuleConfig('page_title')"
        :page-image="getModuleConfig('page_image')"
        :page-kv-image="getModuleConfig('page_kv_image')"
        :header-section="headerSection"
        :meta="meta"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { themeColorFn } from "@/mixins/liff/themeColor";
import Header from "@/components/Page/Liff/Shared/HeaderV3";
import { setTitle, setMeta } from '@/store/modules/liff/helpers';

export default {
  components: {
    Header,
  },
  mixins: [themeColorFn({ themeConfigPage: 'liff_page' })],
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
    }),    
    headerSection() {
      let headerSection = this.getModuleConfig('header_section');
      headerSection.enable_menu_items = this.pageModuleConfig.enable_menu_items ?? headerSection.enable_menu_items;
      headerSection.enable_page_title = this.pageModuleConfig.enable_page_title ?? headerSection.enable_page_title;
      headerSection.enable_page_image = this.pageModuleConfig.enable_page_image ?? headerSection.enable_page_image;
      headerSection.enable_page_kv_image = this.pageModuleConfig.enable_page_kv_image ?? headerSection.enable_page_kv_image;
      return headerSection;
    },
    pageModuleConfig() {
      const key = this.$route.params.autoPage + '_page';
      return this.getModuleConfig(key);
    },
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]('liff_page', key);
    },
    setBrowserTitle() {
      if (this.pageModuleConfig.browser_title) {
        setTitle(this.pageModuleConfig.browser_title);
        setMeta('og:site_title', this.pageModuleConfig.browser_title);
      }
    },
  },
  mounted() {
    this.setBrowserTitle();
  },
};
</script>

<style lang="scss">
@import "../../../assets/css/liff/main.css";
@import "../../../assets/css/liff/liff_init_theme_config.css";

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
  --s-danger: #fe0000;
}

.s-container {
  min-height: 100vh;
}

.page {
  padding: 16px 12px;
  background: var(--liff-content_bg_color);

  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 16px;
    text-align: center;
    color: var(--liff-primary_text_color) !important;
  }

  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color) !important;
    margin-bottom: 16px;
    text-align: center;

    b {
      color: var(--primary-color) !important;
      font-weight: 600;
    }
  }

  &__content{
    a { text-decoration: underline;}
  }

  &__button {
    padding: 12px;
    color: var(--liff-primary_text_color) !important;
  }
}
</style>
